/** DjiniousWorkflow — the graph automation engine behind workflow.djinious.com. */
export const BRAND = "DjiniousWorkflow";

/**
 * The descriptor says what the product IS, so the wordmark alone answers it.
 * The short form exists because the full one is much wider and would push the
 * header into a horizontal scroll on a phone — see Nav.tsx.
 */
export const WORDMARK_SUB = "Build · Run · Watch · Publish";
export const WORDMARK_SUB_SHORT = "Graph automation engine";

export const NAV_LINKS: { label: string; to: string }[] = [
  { label: "Platform", to: "/platform" },
  { label: "Studio", to: "/studio" },
  { label: "AI & agents", to: "/ai" },
  { label: "Reliability", to: "/reliability" },
];

export const FOOTER_TAGLINE =
  "Build the graph, run it on a schedule or a webhook, watch every node as it executes, and leave a page behind — with the run state in the database rather than in whichever process happened to start it.";

/**
 * The four stages a graph goes through. These are the page's structural spine:
 * the rail in the left margin, the section markers, and the order of the
 * argument all come from here. They name parts of the product that exist — the
 * editor and its catalog, the dispatcher with its schedules and triggers, the
 * run monitor with its waits, and the views, artifacts and records a graph
 * writes — not invented chapter numbers.
 */
export const LOOP_STAGES = [
  { id: "build", label: "Build", note: "330 nodes, one canvas" },
  { id: "run", label: "Run", note: "Cron, webhook, API, agent" },
  { id: "watch", label: "Watch", note: "Live, node by node" },
  { id: "publish", label: "Publish", note: "Pages, records, files" },
] as const;

export type LoopStageId = (typeof LOOP_STAGES)[number]["id"];

/** Where the app itself lives — the "sign in" destination, not a marketing page. */
export const APP_URL = "https://workflow.djinious.xyz";

/** Where the demo form POSTs. Override with VITE_DEMO_ENDPOINT to swap delivery later. */
export const DEMO_ENDPOINT =
  (import.meta.env.VITE_DEMO_ENDPOINT as string | undefined) ?? "/api/demo-request";
